import { memo } from "react"
import SummaryContainerStyled from "@Components/Summary/Summary.styled"
import { IMenu } from "@Interfaces/IMenu"
import CardOption from "@Components/Summary/SummaryOption/CardOption"
import { GridContainer } from "@Theme/common/Grid.styled"

const SummaryOptions = memo(({ summaryOptions }: { summaryOptions: IMenu[] }) => {
  return (
    <SummaryContainerStyled>
      <p className="title-summary">Resumen de actividades</p>
      <GridContainer minSize="320px">
        {summaryOptions.map(({ icon, optionCount, path, title, stateLocation }) => (
          <CardOption
            key={`${path}-${title}`}
            icon={icon}
            optionCount={optionCount}
            path={path}
            title={title}
            stateLocation={stateLocation}
          />
        ))}
      </GridContainer>
    </SummaryContainerStyled>
  )
})

export default SummaryOptions
